const route = (resolve) => ({
  async: ['$q', function ($q) {
    const defer = $q.defer();

    resolve(defer.resolve);

    return defer.promise;
  }]
});

export default app => {
  const $inject = ['$urlRouterProvider', '$stateProvider'];

  const BaseRoutes = function ($urlRouterProvider, $stateProvider) {
    $urlRouterProvider.when('', '/');
    $urlRouterProvider.when('/', '/search');
    $urlRouterProvider.when("/my-bookings","/manage-bookings");
    $urlRouterProvider.when("/my-bookings/:itineraryId/:passengerId","/manage-bookings/:itineraryId/:passengerId");

    $urlRouterProvider.otherwise(($injector) => {
      const $state = $injector.get('$state');
      $state.go('app.error', {}, { location: false });
    });

    $stateProvider
      .state('app', {
        url: '',
        abstract: true,
        template: '<ui-view/>',
        params: {
          settingsRequired: true,
          registrationRequired: true,
          userInfoRequired: true
        }
      })

      .state('app.home', {
        url: '',
        abstract: true,
        template: '<lb-home></lb-home>',
        resolve: Object.assign({}, route((callback) =>
          require.ensure([], () => {
            const lbHome = require('../components/lbHome').name;
            callback(app.register(lbHome))
          })
        )),
        params: {
          allowNoSettingsForConsultant: true
        }
      })

      .state('app.home.manage', {
        url: '/manage-bookings',
        template: '<lb-my-bookings></lb-my-bookings>',
        resolve: route(callback =>
          require.ensure([], () => {
            window.svelteStore.userDebtor.set(JSON.parse(localStorage.getItem('CURRENT_USER_debtor')));
            window.svelteStore.userInfo.set(JSON.parse(localStorage.getItem('CURRENT_USER_userInfo')));

            const component = require('../components/lbManageBookings/lbMyBookings').name;
            callback(app.register(component));
          })
        ),
        params: {
          pageTitle: 'Manage Bookings',
          bodyClass: 'bg-myBookings'
        }
      })

      .state('app.booking', {
        url: '',
        abstract: true,
        template: '<lb-booking></lb-booking>',
        resolve: Object.assign({}, route((callback) =>
          require.ensure([], () => {
            const component = require('../components/lbBooking').name;
            callback(app.register(component))
          })
        )),
        params: {
          searchRequired: true,
        }
      })

      .state('app.booking.flights', {
        url: '/flights',
        template: '<lb-search-results search-type="\'Travel\'"></lb-search-results>',
        resolve: route(callback =>
          require.ensure([], () => {
            const lbSearchResults = require('../components/lbSearchResults').name;
            callback(app.register(lbSearchResults))
          })
        ),
        params: {
          pageTitle: 'Search Results - Flights',
          bodyClass: 'bg-flights',
          searchRequired: true
        }
      })
      .state('app.booking.flights2', {
        url: '/flights/{id}',
        controller: ['$state', function($state){
          window.svelteStore.setItineraryId('search', $state.params.id);
          $state.go('app.booking.flights');
        }]
      })
      .state('app.booking.rail', {
        url: '/rail',
        template: '<lb-search-results search-type="\'Rail\'"></lb-search-results>',
        resolve: route(callback =>
          require.ensure([], () => {
            const lbSearchResults = require('../components/lbSearchResults').name;
            callback(app.register(lbSearchResults))
          })
        ),
        params: {
          pageTitle: 'Search Results - Rail',
          bodyClass: 'bg-rail',
          searchRequired: true,
        }
      })
      .state('app.booking.rail2', {
        url: '/rail/{id}',
        controller: ['$state', function($state){
          window.svelteStore.setItineraryId('search', $state.params.id);
          $state.go('app.booking.rail');
        }]
      })
      .state('app.booking.cars', {
        url: '/cars',
        template: '<lb-search-results search-type="\'Cars\'"></lb-search-results>',
        resolve: route(callback =>
          require.ensure([], () => {
            const lbSearchResults = require('../components/lbSearchResults').name;
            callback(app.register(lbSearchResults))
          })
        ),
        params: {
          pageTitle: 'Search Results - Cars',
          bodyClass: 'bg-cars',
          searchRequired: true,
        }
      })
      .state('app.booking.cars2', {
        url: '/cars/{id}',
        controller: ['$state', function($state){
          window.svelteStore.setItineraryId('search', $state.params.id);
          $state.go('app.booking.cars');
        }]
      })
      .state('app.bookingConfirmation', {
        url: '/confirmation',
        template: '<lb-booking-confirmation></lb-booking-confirmation>',
        resolve: Object.assign({}, route((callback) =>
          require.ensure([], () => {
            const lbBookingConfirmation = require('../components/lbBookingConfirmation').name;
            callback(app.register(lbBookingConfirmation));
          })
        )),
        params: {
          pageTitle: 'Booking Confirmation',
          bodyClass: 'bg-bookingConfirmation',
          searchRequired: false
        }
      })

      .state('app.booking.hotels', {
        url: '/hotels',
        template: '<lb-search-results search-type="\'Hotels\'"></lb-search-results>',
        resolve: route(callback =>
          require.ensure([], () => {
            const lbSearchResults = require('../components/lbSearchResults').name;
            callback(app.register(lbSearchResults))
          })
        ),
        params: {
          pageTitle: 'Search Results - Hotels',
          bodyClass: 'bg-hotels'
        }
      })
      .state('app.booking.hotels2', {
        url: '/hotels/{id}',
        controller: ['$state', function($state){
          window.svelteStore.setItineraryId('search', $state.params.id);
          $state.go('app.booking.hotels');
        }]
      })
      .state('app.home.viewBooking', {
        url: '/manage-bookings/{pnr:[0-9A-Z]{6}}',
        template: '<lb-view-booking></lb-view-booking>',
        resolve: route(callback =>
            require.ensure([], () => {
                const component = require('../components/lbManageBookings/lbViewBooking').name;
                callback(app.register(component))
              }
            )
        ),
        params: {
          pageTitle: 'Manage Bookings - view details',
        }
      })

      .state('app.itinerary', {
        url: '/itinerary',
        template: '<lb-itinerary></lb-itinerary>',
        resolve: route(callback =>
          require.ensure([], () => {
            const lbItinerary = require('../components/itinerary/lbItinerary/lbItinerary').name;
            callback(app.register(lbItinerary))
          })
        ),
        params: {
          pageTitle: 'Itinerary',
          bodyClass: 'section-itinerary',
          isRedirect: false
        }
      })
      .state('app.itinerary2', {
        url: '/itinerary/{id}',
        controller: ['$state', function($state){
          window.svelteStore.setItineraryId('search', $state.params.id);
          $state.go('app.itinerary');
        }]
      })
      .state('app.seatmaps', {
        url: '/seatmaps/{itineraryId}/{paxId}',
        template: '<lb-seat-maps></lb-seat-maps>',
        resolve: {
          route: ['$q', $q => {
            const deferred = $q.defer();

            require.ensure([], () => {
              const lbSeatMaps = require('../components/seatMaps/lbSeatMaps/lbSeatMaps').name;
              deferred.resolve(app.register(lbSeatMaps));
            });

            return deferred.promise;
          }],
          setActivePax: ['$q', '$stateParams', 'stateResolveService', ($q, $stateParams, stateResolveService) => {
            const deferred = $q.defer();
            return stateResolveService.setActivePax($stateParams, deferred);
          }]
        },
        params: {
          pageTitle: 'Seat Maps',
          bodyClass: 'bg-seat-maps',
          isRedirect: false
        }
      })

      .state('app.seatmaps.map', {
        url: '/{activePaxId}/{flightId}/{transportIndex}',
        template: '<lb-seat-map-container></lb-seat-map-container>',
        resolve: {
          route: ['$q', $q => {
            const deferred = $q.defer();

            require.ensure([], () => {
              const lbSeatMapContainer = require('../components/seatMaps/lbSeatMapContainer/lbSeatMapContainer').name;
              deferred.resolve(app.register(lbSeatMapContainer));
            });

            return deferred.promise;
          }],
          setActiveSeatMap: ['$q', '$stateParams', 'setActivePax', 'stateResolveService', ($q, $stateParams, setActivePax, stateResolveService) => {
            const deferred = $q.defer();
            return stateResolveService.setActiveSeatMap($stateParams, deferred);
          }],
        },
        params: {
          pageTitle: 'Seat Maps - View Map',
          bodyClass: 'bg-seat-maps',
          isRedirect: false
        }
      })

      .state('app.transfers', {
        url: '/airport-transfers/{itineraryId}',
        template: '<lb-airport-transfers></lb-airport-transfers>',
        resolve: route(callback =>
            require.ensure([], () => {
                const component = require('../components/lbAirportTransfers').name;
                callback(app.register(component))
              }
            )
        ),
        params: {
          pageTitle: 'Airport Transfers',
        }
      })
  };

  BaseRoutes.$inject = $inject;

  return BaseRoutes;
};



// WEBPACK FOOTER //
// ./src/routes/routes.base.js